import { ArrowUpRight } from 'lucide-react';

const UrlPreview = ({ label, url }: { label?: string; url?: string }) => (
  <div className="flex flex-col gap-2">
    {label && <p className="text-xs text-gray-500">{label}</p>}
    {url ? (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center text-blue-600 hover:underline text-xs font-medium space-x-1"
      >
        <span>Open Link</span>
        <ArrowUpRight size={14} />
      </a>
    ) : (
      <p className="text-sm text-gray-800">-</p>
    )}
  </div>
);

export default UrlPreview;
